/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamLangsId200,
  GetApiV1ExamLangsId401,
  GetApiV1ExamLangsId404,
  GetApiV1ExamLangsId500,
  GetApiV1ExamLangsIdPathParams,
  GetApiV1ExamLangsIdQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamLangsId.ts";
import { examLangUpdateViewModelSchema } from "../examLangUpdateViewModelSchema.ts";

export const getApiV1ExamLangsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamLangsId200Schema = z.lazy(
  () => examLangUpdateViewModelSchema,
) as unknown as ToZod<GetApiV1ExamLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsId500>;

export const getApiV1ExamLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1ExamLangsId200Schema,
) as unknown as ToZod<GetApiV1ExamLangsIdQueryResponse>;
